import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, getGuestName, slDateTime } from "@/lib/api";

export default function Guestbook({ slug, canWrite }) {
  const [items, setItems] = useState([]);
  const [name, setName] = useState(getGuestName());
  const [message, setMessage] = useState("");
  const [hp, setHp] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get(`/public/w/${slug}/guestbook`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [slug]); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post(`/public/w/${slug}/guestbook`, { name, message, website: hp || null });
      setItems((cur) => [r.data, ...cur]);
      setMessage("");
      toast.success("Hvala za tvoje lepe besede!");
    } catch (er) { toast.error(errMsg(er)); }
    setBusy(false);
  };

  return (
    <section className="space-y-8" data-testid="guestbook">
      {canWrite && (
        <form onSubmit={submit} className="card-lux p-5 sm:p-6 space-y-3">
          <p className="font-display text-2xl">Zapiši sporočilo za mladoporočenca</p>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Ime in priimek" required minLength={2} maxLength={80} className="w-full h-12 px-4 rounded-xl border border-[#DFD5C5] bg-white focus:outline-none focus:ring-2 focus:ring-[#C5A880]" data-testid="guestbook-name-input" />
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Želiva vama veliko ljubezni in sreče!" required maxLength={600} rows={3} className="w-full p-4 rounded-xl border border-[#DFD5C5] bg-white focus:outline-none focus:ring-2 focus:ring-[#C5A880]" data-testid="guestbook-message-input" />
          <input value={hp} onChange={(e) => setHp(e.target.value)} tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" />
          <button disabled={busy} className="btn-dark w-full h-12 disabled:opacity-50" data-testid="guestbook-submit-button">Pošlji sporočilo</button>
        </form>
      )}
      {items.length === 0 ? (
        <p className="text-center text-[#6C6560] py-6" data-testid="guestbook-empty">Knjiga gostov je še prazna.</p>
      ) : (
        <div className="columns-1 sm:columns-2 gap-4">
          {items.map((g) => (
            <article key={g.id} className="masonry-item mb-4 card-lux p-6" data-testid="guestbook-entry">
              <p className="font-display text-xl leading-snug italic">“{g.message}”</p>
              <div className="gold-rule my-4 opacity-60" />
              <p className="text-sm font-medium">{g.name}</p>
              <p className="text-xs text-[#968E87]">{slDateTime(g.created_at)}</p>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
